// Top-Level-App. Auth-Gate: kein User -> LoginScreen, sonst Workspace.
// Beim Mount: AuthContext validiert gespeicherten Token gegen /me; bis dahin Loading-State.

import { useTranslation } from "react-i18next";
import { useAuth } from "./auth/AuthContext.js";
import { LoginScreen } from "./auth/LoginScreen.js";
import { UserMenu } from "./auth/UserMenu.js";
import { LanguageSwitcher } from "./i18n/LanguageSwitcher.js";
import { Workspace } from "./workspace/Workspace.js";
import "./App.css";

export function App(): JSX.Element {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading && !user) {
    return (
      <output className="app-loading" aria-live="polite">
        <span className="app-loading-dot" />
        <span>{t("app.loading")}</span>
      </output>
    );
  }

  if (!user) return <LoginScreen />;

  return (
    <div className="app-shell">
      <header className="app-header">
        <h1 className="app-title">{t("app.title")}</h1>
        <div className="app-header-right">
          <UserMenu />
          <LanguageSwitcher />
        </div>
      </header>
      <main className="app-main app-main-flush">
        <Workspace />
      </main>
    </div>
  );
}
